(function(){
  'use strict';
  if (window.__ayurSummerGiftsInit) return;
  window.__ayurSummerGiftsInit = true;

  /* ---- CONFIG ----
     Tongue scraper gift uses a DEDICATED £0 product (no Shopify discount involved) so it can never
     conflict with the Hammered Glasses BxGy discount — Shopify only lets one BxGy discount claim a
     given prerequisite item (the bottle) at a time, so running two BxGy discounts that both use the
     bottle as a trigger is not reliable. The glasses gift keeps using the real automatic discount
     since it runs alone now. */
  var BOTTLE_PRODUCT_IDS = [8116232978541, 8121513312365, 8116233109613]; /* Hammered Copper Bottle (all variants/sizes/packs), Copper Water Dispenser, Ayurvedic Copper Set (Bottle + 2 Glasses) */
  var TONGUE_GIFT_VARIANT_ID = 45355441455213; /* Dedicated £0 "Free Gift" tongue scraper variant */
  var GLASSES_VARIANT_ID = 45326647263341; /* Hammered Copper Glasses, Pack of 2 (real product, made free via BxGy discount) */
  var GLASSES_THRESHOLD_PENCE = 4999; /* £49.99 — matches the live "Summer Sale: Free Copper Glasses on £50+ Spend" BxGy discount's actual purchase-amount requirement, so the two never disagree at the boundary */
  var GIFT_KEY = '_summer_gift';

  function fmt(c){ return '£' + (c/100).toFixed(2); }
  function getCart(){ return fetch('/cart.js').then(function(r){ return r.json(); }); }

  function addItem(variantId, qty){
    var props = {}; props[GIFT_KEY] = '1';
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty, properties: props }] })
    });
  }
  function changeLine(key, qty){
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }
  function isGiftItem(item, variantId){
    return item.variant_id === variantId && item.properties && item.properties[GIFT_KEY] === '1';
  }
  function findGiftLine(cart, variantId){
    var found = null;
    cart.items.forEach(function(i){ if (isGiftItem(i, variantId)) found = i; });
    return found;
  }
  /* Qualifying spend used for the £50 threshold check. Deliberately EXCLUDES any line tagged
     as our own free gift (GIFT_KEY) and sums final_line_price (post other-discount, e.g. AYURVEDA10)
     of everything else.

     Why not just use cart.total_price: that's Shopify's post-discount cart total, which INCLUDES
     the glasses gift line itself. The moment qualifying spend dips just under the threshold, Shopify's
     BxGy discount on that line lapses and it reverts to its full price — and that full price gets
     added straight back into cart.total_price, often pushing the total back over £50 again purely
     because of the now-undiscounted free item. The script would then think the gift is still owed,
     never remove it, and it would sit in the cart at full price forever (the bug reported: glasses
     not removed below £50, shown at full price, still tagged FREE GIFT, needing manual removal).
     Excluding gift lines from the qualifying-spend calculation breaks that feedback loop entirely. */
  function nonGiftSubtotal(cart){
    var sum = 0;
    cart.items.forEach(function(item){
      var isGift = item.properties && item.properties[GIFT_KEY] === '1';
      if (!isGift) sum += item.final_line_price;
    });
    return sum;
  }

  var syncing = false;

  function renderCartPageItems(cart){
    var itemsWrap = document.querySelector('.ayur-cart-page__items');
    if (!itemsWrap) return;
    if (cart.item_count === 0) return;
    var html = '';
    cart.items.forEach(function(item){
      var isGift = (item.properties && item.properties[GIFT_KEY] === '1');
      /* Free-gift lines are quantity-locked — no +/- counter, since summer-gifts.js
         owns their quantity automatically based on cart contents/spend. */
      var qtyHtml = isGift
        ? '<span class="ayur-qty-num" style="color:#92400E;font-weight:700;">Qty ' + item.quantity + '</span>'
        : '<div class="ayur-qty-control">'
          + '<button type="button" class="ayur-qty-btn" onclick="cartPageUpdateItem(\'' + item.key + '\', ' + (item.quantity - 1) + ', this)">&minus;</button>'
          + '<span class="ayur-qty-num">' + item.quantity + '</span>'
          + '<button type="button" class="ayur-qty-btn" onclick="cartPageUpdateItem(\'' + item.key + '\', ' + (item.quantity + 1) + ', this)">+</button>'
          + '</div>';
      html += '<div class="ayur-cart-item" data-key="' + item.key + '">'
        + (item.image ? '<a href="' + item.url + '" class="ayur-cart-item__img-link"><img src="' + item.image + '" alt="" class="ayur-cart-item__img" width="120" height="120" loading="lazy"></a>' : '')
        + '<div class="ayur-cart-item__info"><a href="' + item.url + '" class="ayur-cart-item__name">' + item.product_title + (isGift ? ' <span style="color:#92400E;font-size:11px;font-weight:700;">(FREE GIFT)</span>' : '') + '</a>'
        + ((item.variant_title && item.variant_title !== 'Default Title') ? '<p class="ayur-cart-item__variant">' + item.variant_title + '</p>' : '')
        + '<div class="ayur-cart-item__controls">' + qtyHtml
        + '<span class="ayur-cart-item__price">' + fmt(item.final_line_price) + '</span></div></div>'
        + '<button type="button" class="ayur-cart-item__remove" onclick="cartPageUpdateItem(\'' + item.key + '\', 0, this)">&times;</button></div>';
    });
    itemsWrap.innerHTML = html;
    var totalEl = document.querySelector('.ayur-cart-summary__total');
    if (totalEl) totalEl.textContent = fmt(cart.total_price);
  }

  /* Renders the "spend £X more" / "free gift unlocked" banner INSTANTLY from a cart object
     already in memory — no network call, so it never lags behind a quick-add or remove click. */
  function renderGiftBanner(cart){
    var bottlePresent = cart.items.some(function(i){ return BOTTLE_PRODUCT_IDS.indexOf(i.product_id) !== -1; });
    var hasTongueLine = !!findGiftLine(cart, TONGUE_GIFT_VARIANT_ID);
    var giftGlassesLine = findGiftLine(cart, GLASSES_VARIANT_ID);
    var qualifyingSpend = nonGiftSubtotal(cart);
    var remaining = GLASSES_THRESHOLD_PENCE - qualifyingSpend;

    var lines = [];
    if (bottlePresent && hasTongueLine) lines.push('🎁 Free Copper Tongue Scraper added to your order!');
    if (giftGlassesLine && qualifyingSpend >= GLASSES_THRESHOLD_PENCE) { lines.push('🎉 Free Hammered Copper Glasses unlocked!'); }
    else if (cart.item_count > 0 && remaining > 0) { lines.push('Spend <strong>' + fmt(remaining) + '</strong> more to unlock FREE Hammered Copper Glasses'); }

    var drawerWrap = document.getElementById('cart-drawer__items');
    var pageWrap = document.querySelector('.ayur-cart-page__summary');

    if (lines.length === 0) {
      document.querySelectorAll('.ayur-gift-banner').forEach(function(b){ b.remove(); });
      return;
    }

    var pct = Math.min(100, Math.round(qualifyingSpend * 100 / GLASSES_THRESHOLD_PENCE));
    var bannerHtml = '<div class="ayur-gift-banner">' + lines.map(function(l){ return '<div class="ayur-gift-banner__line">' + l + '</div>'; }).join('')
      + ((!giftGlassesLine || qualifyingSpend < GLASSES_THRESHOLD_PENCE) ? '<div class="ayur-gift-banner__bar"><div class="ayur-gift-banner__bar-fill" style="width:' + pct + '%"></div></div>' : '')
      + '</div>';

    if (drawerWrap && cart.item_count > 0) {
      var existing = drawerWrap.querySelector('.ayur-gift-banner');
      if (existing) existing.remove();
      drawerWrap.insertAdjacentHTML('afterbegin', bannerHtml);
    }
    if (pageWrap) {
      var existingP = pageWrap.querySelector('.ayur-gift-banner');
      if (existingP) existingP.remove();
      var titleEl = pageWrap.querySelector('.ayur-cart-summary__title');
      if (titleEl) titleEl.insertAdjacentHTML('afterend', bannerHtml);
    }
  }

  function refreshCartViews(cart){
    if (typeof window.renderCartDrawer === 'function') window.renderCartDrawer(cart);
    if (typeof window.ayurSyncCardStates === 'function') window.ayurSyncCardStates(cart);
    if (document.getElementById('cart-page-root')) renderCartPageItems(cart);
    renderGiftBanner(cart);
  }

  /* Reconciles gift lines against a cart we already have in hand.
     1. Paints the banner immediately — zero network latency.
     2. Only talks to the server if a gift line genuinely needs adding/removing,
        and runs both possible actions in PARALLEL (they touch different lines) instead
        of one-after-another, roughly halving the wait when both fire at once.
     3. If a sync is already in flight when a newer cart event arrives, that newer cart is
        queued and re-checked the moment the in-flight sync finishes, instead of being silently
        dropped — otherwise a fast follow-up change (e.g. two quick clicks) could leave the gift
        lines stale because its correction never ran. */
  var pendingCart = null;

  function syncGifts(cart){
    renderGiftBanner(cart);
    if (syncing) { pendingCart = cart; return Promise.resolve(); }

    var bottlePresent = cart.items.some(function(i){ return BOTTLE_PRODUCT_IDS.indexOf(i.product_id) !== -1; });
    var tongueGiftLine = findGiftLine(cart, TONGUE_GIFT_VARIANT_ID);
    /* Qualifying spend excludes gift lines themselves — see nonGiftSubtotal() comment above
       for why cart.total_price can't be used here without creating a remove-never-fires loop. */
    var qualifyingSpend = nonGiftSubtotal(cart);
    var desiredGlasses = qualifyingSpend >= GLASSES_THRESHOLD_PENCE ? 1 : 0;
    var giftGlassesLine = findGiftLine(cart, GLASSES_VARIANT_ID);

    var actions = [];
    if (bottlePresent && !tongueGiftLine) actions.push(function(){ return addItem(TONGUE_GIFT_VARIANT_ID, 1); });
    else if (!bottlePresent && tongueGiftLine) actions.push(function(){ return changeLine(tongueGiftLine.key, 0); });

    /* Check giftGlassesLine (our own tagged free line) — NOT "any glasses line in the cart".
       Checking for any line meant a customer who manually adds/buys their own pack of glasses
       permanently blocked the automatic free gift from ever being added, even after crossing £50,
       because the script thought "glasses already present" and stopped looking. */
    if (desiredGlasses > 0 && !giftGlassesLine) actions.push(function(){ return addItem(GLASSES_VARIANT_ID, 1); });
    else if (desiredGlasses === 0 && giftGlassesLine) actions.push(function(){ return changeLine(giftGlassesLine.key, 0); });

    if (actions.length === 0) return Promise.resolve();

    syncing = true;
    return Promise.all(actions.map(function(fn){ return fn(); }))
      .then(function(){ return getCart(); })
      .then(function(freshCart){
        refreshCartViews(freshCart);
        syncing = false;
        if (pendingCart) { var next = pendingCart; pendingCart = null; return syncGifts(next); }
        return freshCart;
      })
      .catch(function(e){
        console.error('Summer gift sync failed', e);
        syncing = false;
        if (pendingCart) { var next = pendingCart; pendingCart = null; return syncGifts(next); }
      });
  }

  var style = document.createElement('style');
  style.textContent = '.ayur-gift-banner{background:#FFF7ED;border:1px solid #FDE0B2;border-radius:10px;padding:10px 12px;margin-bottom:14px;font-size:12.5px;color:#92400E;font-weight:600;}'
    + '.ayur-gift-banner__line{margin-bottom:4px;}'
    + '.ayur-gift-banner__bar{height:5px;background:#FDE0B2;border-radius:3px;overflow:hidden;margin-top:4px;}'
    + '.ayur-gift-banner__bar-fill{height:100%;background:#92400E;border-radius:3px;transition:width .3s ease;}';
  document.head.appendChild(style);

  /* Reacts to the 'ayur:cart:changed' event dispatched by theme.js right after any
     add/update/remove call resolves — uses the cart object Shopify already returned,
     so no extra /cart.js round trip and no artificial delay before the banner updates. */
  window.addEventListener('ayur:cart:changed', function(e){
    var cart = e.detail && e.detail.cart;
    if (cart) syncGifts(cart);
  });

  function init(){ getCart().then(function(cart){ refreshCartViews(cart); syncGifts(cart); }); }
  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState === 'complete' || document.readyState === 'interactive') init();

  /* Safety net: re-check gift state from a fresh cart fetch whenever the page becomes visible
     again — covers (a) back/forward-cache restores, where this script doesn't re-execute but
     cart state may have changed via another tab/checkout, and (b) the rare case where a cart
     mutation's 'ayur:cart:changed' event fired in the brief window before this deferred script
     finished loading and attaching its listener, so it was silently missed. Cheap (one fetch),
     so safe to run on every pageshow rather than trying to detect which case applies. */
  window.addEventListener('pageshow', function(){ getCart().then(syncGifts); });
})();
